import React, { FC } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import styled from "styled-components";
import LockIcon from "src/components/icons/Lock";

const SslRoot = styled("div")`
    align-items: center;
    display: flex;
    font-size: 12px;
    justify-content: center;

    ${(props) => props.theme.breakpoints.down("desktop")} {
        margin: 20px 0;
    }
`;

const SslIcon = styled("div")`
    height: 25px;
`;

const SslText = styled("div")`
    color: #333;
    margin-left: ${(props) => `${props.theme.spacing.unit}px`};
    width: 160px;
`;

const Ssl: FC<WithTranslation> = ({ t }) => (
    <SslRoot>
        <SslIcon>
            <LockIcon />
        </SslIcon>

        <SslText>{t("ContinueDeal.CreditApp.Ssl.text")}</SslText>
    </SslRoot>
);

export default withTranslation()(Ssl);
